import { render, staticRenderFns } from "./ChinhSachVaQuyenLoi.vue?vue&type=template&id=81ff562e&scoped=true"
import script from "./ChinhSachVaQuyenLoi.vue?vue&type=script&lang=js"
export * from "./ChinhSachVaQuyenLoi.vue?vue&type=script&lang=js"
import style0 from "./ChinhSachVaQuyenLoi.vue?vue&type=style&index=0&id=81ff562e&prod&scoped=true&lang=css"
import style1 from "./ChinhSachVaQuyenLoi.vue?vue&type=style&index=1&id=81ff562e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ff562e",
  null
  
)

export default component.exports